"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListObjectVersionsInput_1 = require("./ListObjectVersionsInput");
var ListObjectVersionsOutput_1 = require("./ListObjectVersionsOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.ListObjectVersions = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "ListObjectVersions",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?versions"
    },
    input: {
        shape: ListObjectVersionsInput_1.ListObjectVersionsInput
    },
    output: {
        shape: ListObjectVersionsOutput_1.ListObjectVersionsOutput
    },
    errors: []
};
//# sourceMappingURL=ListObjectVersions.js.map